export default __webpack_public_path__ + "static/5-0f6658445adb0443289fe602b50d5855.png";